/* tslint:disable */
/* eslint-disable */
/**
 * Tenants API
 * API for managing tenants
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AffectedQuotesResponse,
  OperationResponse,
  PatchTenantCheckoutDateCommand,
  StoredFileIdRequest,
  TenantDto,
  UpsertTenantCommand,
} from '../models/index';
import {
    AffectedQuotesResponseFromJSON,
    AffectedQuotesResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    PatchTenantCheckoutDateCommandFromJSON,
    PatchTenantCheckoutDateCommandToJSON,
    StoredFileIdRequestFromJSON,
    StoredFileIdRequestToJSON,
    TenantDtoFromJSON,
    TenantDtoToJSON,
    UpsertTenantCommandFromJSON,
    UpsertTenantCommandToJSON,
} from '../models/index';

export interface CreateTenantRequest {
    upsertTenantCommand: UpsertTenantCommand;
}

export interface CreateTenantDocumentRequest {
    tenantId: string;
    storedFileIdRequest: StoredFileIdRequest;
    garantId?: string;
}

export interface DeleteTenantByIdRequest {
    tenantId: string;
}

export interface DeleteTenantDocumentRequest {
    tenantId: string;
    storedFileId: string;
    garantId?: string;
}

export interface GetAffectedQuotesByGuarantorIdRequest {
    guarantorId: string;
}

export interface GetAffectedQuotesByTenantIdRequest {
    tenantId: string;
}

export interface GetTenantByIdRequest {
    tenantId: string;
}

export interface UpdateCheckoutDateRequest {
    tenantId: string;
    patchTenantCheckoutDateCommand: PatchTenantCheckoutDateCommand;
}

export interface UpdateTenantRequest {
    tenantId: string;
    upsertTenantCommand: UpsertTenantCommand;
}

/**
 * 
 */
export class TenantsApi extends runtime.BaseAPI {

    /**
     * Create a new tenant
     */
    async createTenantRaw(requestParameters: CreateTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['upsertTenantCommand'] == null) {
            throw new runtime.RequiredError(
                'upsertTenantCommand',
                'Required parameter "upsertTenantCommand" was null or undefined when calling createTenant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/locataires`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertTenantCommandToJSON(requestParameters['upsertTenantCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create a new tenant
     */
    async createTenant(requestParameters: CreateTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch checkout date of a tenant
     */
    async createTenantDocumentRaw(requestParameters: CreateTenantDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling createTenantDocument().'
            );
        }

        if (requestParameters['storedFileIdRequest'] == null) {
            throw new runtime.RequiredError(
                'storedFileIdRequest',
                'Required parameter "storedFileIdRequest" was null or undefined when calling createTenantDocument().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['garantId'] != null) {
            queryParameters['garantId'] = requestParameters['garantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/locataires/{tenantId}/documents`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StoredFileIdRequestToJSON(requestParameters['storedFileIdRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Patch checkout date of a tenant
     */
    async createTenantDocument(requestParameters: CreateTenantDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createTenantDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete tenant by ID
     */
    async deleteTenantByIdRaw(requestParameters: DeleteTenantByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteTenantById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/locataires/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Delete tenant by ID
     */
    async deleteTenantById(requestParameters: DeleteTenantByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteTenantByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete tenant document by ID
     */
    async deleteTenantDocumentRaw(requestParameters: DeleteTenantDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteTenantDocument().'
            );
        }

        if (requestParameters['storedFileId'] == null) {
            throw new runtime.RequiredError(
                'storedFileId',
                'Required parameter "storedFileId" was null or undefined when calling deleteTenantDocument().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['garantId'] != null) {
            queryParameters['garantId'] = requestParameters['garantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/locataires/{tenantId}/documents/{storedFileId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))).replace(`{${"storedFileId"}}`, encodeURIComponent(String(requestParameters['storedFileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Delete tenant document by ID
     */
    async deleteTenantDocument(requestParameters: DeleteTenantDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteTenantDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of quotes that would be affected by modifications to this guarantor
     * Get affected quotes by guarantor ID
     */
    async getAffectedQuotesByGuarantorIdRaw(requestParameters: GetAffectedQuotesByGuarantorIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AffectedQuotesResponse>> {
        if (requestParameters['guarantorId'] == null) {
            throw new runtime.RequiredError(
                'guarantorId',
                'Required parameter "guarantorId" was null or undefined when calling getAffectedQuotesByGuarantorId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/locataires/guarantors/{guarantorId}/devis-impactes`.replace(`{${"guarantorId"}}`, encodeURIComponent(String(requestParameters['guarantorId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AffectedQuotesResponseFromJSON(jsonValue));
    }

    /**
     * Returns a list of quotes that would be affected by modifications to this guarantor
     * Get affected quotes by guarantor ID
     */
    async getAffectedQuotesByGuarantorId(requestParameters: GetAffectedQuotesByGuarantorIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AffectedQuotesResponse> {
        const response = await this.getAffectedQuotesByGuarantorIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of quotes that would be affected by modifications to this tenant
     * Get affected quotes by tenant ID
     */
    async getAffectedQuotesByTenantIdRaw(requestParameters: GetAffectedQuotesByTenantIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AffectedQuotesResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAffectedQuotesByTenantId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/locataires/{tenantId}/devis-impactes`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AffectedQuotesResponseFromJSON(jsonValue));
    }

    /**
     * Returns a list of quotes that would be affected by modifications to this tenant
     * Get affected quotes by tenant ID
     */
    async getAffectedQuotesByTenantId(requestParameters: GetAffectedQuotesByTenantIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AffectedQuotesResponse> {
        const response = await this.getAffectedQuotesByTenantIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tenant by ID
     */
    async getTenantByIdRaw(requestParameters: GetTenantByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantDto>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getTenantById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/locataires/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantDtoFromJSON(jsonValue));
    }

    /**
     * Get tenant by ID
     */
    async getTenantById(requestParameters: GetTenantByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantDto> {
        const response = await this.getTenantByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch checkout date of a tenant
     */
    async updateCheckoutDateRaw(requestParameters: UpdateCheckoutDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateCheckoutDate().'
            );
        }

        if (requestParameters['patchTenantCheckoutDateCommand'] == null) {
            throw new runtime.RequiredError(
                'patchTenantCheckoutDateCommand',
                'Required parameter "patchTenantCheckoutDateCommand" was null or undefined when calling updateCheckoutDate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/locataires/{tenantId}/disable`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchTenantCheckoutDateCommandToJSON(requestParameters['patchTenantCheckoutDateCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Patch checkout date of a tenant
     */
    async updateCheckoutDate(requestParameters: UpdateCheckoutDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateCheckoutDateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a tenant
     */
    async updateTenantRaw(requestParameters: UpdateTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateTenant().'
            );
        }

        if (requestParameters['upsertTenantCommand'] == null) {
            throw new runtime.RequiredError(
                'upsertTenantCommand',
                'Required parameter "upsertTenantCommand" was null or undefined when calling updateTenant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/locataires/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertTenantCommandToJSON(requestParameters['upsertTenantCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Update a tenant
     */
    async updateTenant(requestParameters: UpdateTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
